import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const businessImporterSelectors = importerSelectors(
  'business.importer',
)

export default businessImporterSelectors
